import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "earning"
const EarningIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.375 1.5C13.203 1.5 13.875 2.172 13.875 3V5.25L13.872 5.298C14.52 5.464 15 6.05 15 6.75V7.581Q14.221 7.693 13.5 7.95V6.75H4.5V9H11.503C10.917 9.426 10.392 9.931 9.943 10.5H5.25V12.75H8.7Q8.443 13.471 8.33 14.25H3.75V16.5H8.331Q8.443 17.279 8.7 18H3.75V20.25H9.943C10.392 20.819 10.917 21.324 11.503 21.75H3.75C2.922 21.75 2.25 21.078 2.25 20.25V18C2.25 17.727 2.324 17.47 2.452 17.25 2.324 17.03 2.25 16.773 2.25 16.5V14.25C2.25 13.422 2.922 12.75 3.75 12.75V10.5Q3.751 10.402 3.764 10.306C3.308 10.049 3 9.56 3 9V6.75L3.002 6.7C2.354 6.536 1.875 5.95 1.875 5.25V3C1.875 2.172 2.547 1.5 3.375 1.5zM3.375 5.25H12.375V3H3.375z"
            clipRule="evenodd"
          />
          <path d="M16.695 12.824C17.107 12.887 17.535 13.067 17.887 13.342L17.407 14.088C17.123 13.884 16.74 13.728 16.298 13.728 15.81 13.727 15.526 13.945 15.526 14.227 15.525 14.92 18 14.685 18 16.428 18 17.149 17.482 17.745 16.695 17.918V18.75H15.795V17.934C15.27 17.848 14.677 17.596 14.25 17.157L14.827 16.482C15.187 16.796 15.645 17.022 16.2 17.022 16.71 17.023 16.988 16.757 16.988 16.443 16.988 15.556 14.512 15.932 14.512 14.222 14.512 13.412 15.112 12.972 15.795 12.831V12H16.695z" />
          <path
            fillRule="evenodd"
            d="M16.125 9C19.645 9 22.5 11.854 22.5 15.375S19.646 21.75 16.125 21.75 9.75 18.896 9.75 15.375 12.604 9 16.125 9M16.125 10.5C13.433 10.5 11.25 12.683 11.25 15.375S13.433 20.25 16.125 20.25 21 18.067 21 15.375 18.817 10.5 16.125 10.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EarningIcon
